import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import DetailsCondition from './DetailsCondition/DetailsCondition';
import { vehicleTypes } from '../../../../consts/vehicleTypes';
import { compose } from 'redux'
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';
import VehicleDetailsGeneral from '../../../molecules/VehicleDetailsGeneral';


const DetailsTab = ({ details, isMobile, vehicleType, t, }) => {
  if (!Object.keys(details).length) {
    return null
  }
  const detailsArray = {
    [vehicleTypes.Motorbike]: [
      { label: t('motor_general_condition'),
        score: get(details, ['vehicle', 'general_condition_note']),
        value: t(`enums.general_conditions.${get(details, ['vehicle', 'general_condition'])}`), },
      { label: t('consumables_condition'),
        score: get(details, ['vehicle', 'consumables_condition_note']),
        value: t(`enums.consumables_condition.${get(details, ['vehicle', 'consumables_condition'])}`), },
      { label: t('motor_tires'),
        score: get(details, ['vehicle', 'tires_note']),
        value: t(`enums.tires.${get(details, ['vehicle', 'tires'])}`), },
      { label: t('next_hu'),
        score: get(details, ['vehicle', 'next_hu_note']),
        value: get(details, ['vehicle', 'next_hu']), },
      { label: t('motor_total_mileage'),
        score: get(details, ['vehicle', 'total_mileage_note']),
        value: get(details, ['vehicle', 'total_mileage']), },
      { label: t('motor_last_inspection'),
        score: get(details, ['vehicle', 'last_inspection_note']),
        value: get(details, ['vehicle', 'last_inspection']) || t('not_specified'), },
      { label: t('number_of_previous_owners'),
        score: get(details, ['vehicle', 'number_of_previous_owners_note']),
        value: t(`enums.number_of_previous_owners_options.${get(details, ['vehicle', 'number_of_previous_owners'])}`), }
    ],
    [vehicleTypes.AgriculturalMachine]: [
      { label: t('agricultural_general_condition'),
        score: get(details, ['vehicle', 'general_condition_note']),
        value: t(`enums.agricultural_general_condition.${get(details, ['vehicle', 'general_condition'])}`), },
      { label: t('agricultural_meter'),
        score: get(details, ['vehicle', 'meter_note']),
        value: `${get(details, ['vehicle', 'meter'])} ${get(details, ['vehicle', 'meter_type'])}`, },
      { label: t('production_year'),
        score: get(details, ['vehicle', 'production_year_note']),
        value: get(details, ['vehicle', 'production_year']), }
    ],
    [vehicleTypes.Camper]: [
      { label: t('chassis_mark'),
        score: 5,
        value: get(details, ['vehicle', 'chassis_mark']) ? get(details, ['vehicle', 'chassis_mark']) : 'null null', },
      { label: t('camper_type'),
        score: 5,
        value: t(`enums.camper_type_options.${get(details, ['vehicle', 'camper_type'])}`), },
      { label: t('number_of_previous_owners'),
        score: get(details, ['vehicle', 'number_of_previous_owners_note']),
        value: t(`enums.number_of_previous_owners_options.${get(details, ['vehicle', 'number_of_previous_owners'])}`), },
      { label: t('camper_total_mileage'),
        score: get(details, ['vehicle', 'total_mileage_note']),
        value: get(details, ['vehicle', 'total_mileage']), },
      { label: t('camper_last_inspection'),
        score: get(details, ['vehicle', 'last_inspection_note']),
        value: get(details, ['vehicle', 'last_inspection']) || t('not_specified'), },
      { label: t('next_hu'),
        score: get(details, ['vehicle', 'next_hu_note']),
        value: get(details, ['vehicle', 'next_hu']), }
    ],
  }

  const detailsGeneralArray = {
    [vehicleTypes.Motorbike]: [
      { key: 'accident_free', value: details.vehicle.accident_free,  positiveValues: [true], },
      { key: 'not_wrecked', value: details.vehicle.not_wrecked,  positiveValues: [true], },
      { key: 'original_lacquer', value: details.vehicle.original_lacquer,  positiveValues: [true], },
      { key: 'import_vehicle', value: details.vehicle.import_vehicle, positiveValues: [false], },
      { key: 'vin', value: details.vehicle.vin, positiveValues: [true], },
      { key: 'rental', value: details.vehicle.rental, positiveValues: [false], },
      { key: 'financed_vehicle', value: details.financed_vehicle, positiveValues: [false], },
      { key: 'service_booklet', value: details.vehicle.service_booklet, positiveValues: ['existing', 'run',  'digitally_run'], },
      { key: 'abs', value: details.vehicle.abs, positiveValues: [true], },
      { key: 'defects', value: details.vehicle.defects, positiveValues: [false], }
    ],
    [vehicleTypes.AgriculturalMachine]: [{ key: 'defects', value: details.vehicle.defects, positiveValues: [false], }],
    [vehicleTypes.Camper]: [
      { key: 'defects', value: details.vehicle.defects, positiveValues: [false], },
      { key: 'accident_free', value: details.vehicle.accident_free,  positiveValues: [true], },
      { key: 'rental', value: details.vehicle.rental, positiveValues: [false], },
      { key: 'service_booklet', value: details.vehicle.service_booklet, positiveValues: ['run'], }
    ],
  }
  return (
    <div className="row" style={{ marginLeft: (isMobile ? null : '-5px'), }}>
      <DetailsCondition
        details={detailsArray[vehicleType].filter((item) => item.value !== 'null null')}
      />
      { isMobile &&
        <VehicleDetailsGeneral
          fields={detailsGeneralArray[vehicleType]}
        />
      }
    </div>
  );
};

DetailsTab.propTypes = {
  t: PropTypes.func.isRequired,
  details: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)),
};

DetailsTab.defaultProps = {
  isMobile: false,
  vehicleType: vehicleTypes.Motorbike,
};

const mapStateToProps = (state) => {
  return {
    details: get(state, ['offerDetails', 'data']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),
  };
};

export default compose(
  connect(mapStateToProps),
  withScopedTranslations('offer_details.details_condition')
)(DetailsTab);
